import React from 'react'
import PropTypes from 'prop-types'

const Svg = ({ children, ...restProps }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" {...restProps}>
    {children}
  </svg>
)

Svg.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Svg
export SvgSiteLogo from './SvgSiteLogo'
export SvgLicenseDriver from './SvgLicenseDriver'
export SvgLicenseCpr from './SvgLicenseCpr'
export SvgPlus from './SvgPlus'
export SvgRefresh from './SvgRefresh'
export SvgCross from './SvgCross'



// WEBPACK FOOTER //
// ../source/components/Svg/index.js